var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-from-to"},[_c('div',{staticClass:"wp-from-to__from"},[_vm._t("from")],2),_c('div',{staticClass:"wp-from-to__delimiter"},[_c('span',[_vm._v(_vm._s(_vm.delimiter))])]),_c('div',{staticClass:"wp-from-to__to"},[_vm._t("to")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }